import React from "react";

const ExamGrades = () => {
  return (
    <div>
      <h2>ExamGrades</h2>
    </div>
  );
};

export default ExamGrades;
